import * as Sentry from "@sentry/react";
import { environment, isProductionEnvironment } from "mt-shared/environment";

Sentry.init({
  dsn: "https://492db502cafa442808f8a5341cdd9c09@o4506425710018560.ingest.us.sentry.io/4509437911040000",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracePropagationTargets: [import.meta.env.VITE_API_URL],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment,
  enabled: isProductionEnvironment,
});
